export const CLASSNAME = 'loader';
export const DEFAULT_SIZE = 'm';
